<template>
  <div class="mywallet">
    <div class="page-title">
      <div>我的钱包</div>
    </div>
    <div class="wallet-basic-box">
      <img class="bg-mywallet" src="@/assets/bg_mywallet.png" />
      <div class="wallet-basic-inner">
        <div class="basic-item account-surplus">
          <div class="label">账户余额（元）</div>
          <div class="val-cont">{{ userBalance.cust_stat_left_money_num || '0.00' }}</div>
        </div>
        <div class="line"></div>
        <div class="basic-item canuse-surplus">
          <div class="label">可提现金额（元）</div>
          <div class="val-cont">{{ userBalance.cust_stat_left_money_num || '0.00' }}</div>
        </div>
        <div class="line"></div>
        <div class="basic-item tixian-surplus">
          <div class="label">已提现金额（元）</div>
          <div class="val-cont">0</div>
        </div>
      </div>
      <div class="btn-withdrawal" @click="handleWithdrawal">
        <div class="btn-withdrawal-main">提现</div>
        <img class="icon-remind" src="@/assets/icon_remind.png" />
      </div>
    </div>
    <div class="nav-tabpanel-box">
      <div :class="['item-nav-box', selTabIndex === 0 ? 'active' : '']" @click="handleSelTab(0)">
        交易记录
      </div>
      <div :class="['item-nav-box', selTabIndex === 1 ? 'active' : '']" @click="handleSelTab(1)">
        提现记录
      </div>
    </div>
    <template v-if="selTabIndex === 0">
      <div class="table-header-box cell-row">
        <div class="cell-column">订单号</div>
        <div class="cell-column">订单类型</div>
        <div class="cell-column">交易时间</div>
        <div class="cell-column">金额</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">

        <template v-if="recordList.length">
        <div v-for="(item, idx) in recordList" :key="idx" class="datalist-row">
          <div class="cell-row">
            <div class="cell-column">{{ item.id_public_consume_record }}</div>
            <div class="cell-column">
              {{ item.consume_type | showConsumeType }}
            </div>
            <div class="cell-column">{{ item.time_consume | showTime }}</div>
            <div :class="[
                'cell-column',
                'consumemoney_status',
                `consumemoney_status${item.consumeType}`,
              ]">
              {{ item.consume_type === 3 ? "+" : "" }} {{ item.consume_price|showMoney }}
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-if="selTabIndex === 1">
      <div class="table-header-box cell-row">
        <div class="cell-column">提现流水号</div>
        <div class="cell-column">提现平台</div>
        <div class="cell-column">提现金额</div>
        <div class="cell-column">申请时间</div>
        <div class="cell-column">提现状态</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="recordList.length">
        <div v-for="(item, idx) in recordList" :key="idx" class="datalist-row">
          <div class="cell-row">
            <div class="cell-column">{{ item.id_public_consume_record }}</div>
            <div class="cell-column">微信</div>
            <div class="cell-column withdrawmoney">{{ item.consume_price|showMoney }}</div>
            <div class="cell-column">{{ item.time_consume|showTime }}</div>
            <div :class="['cell-column','withdrawalstatus',`withdrawalstatus${item.consume_status}`]">{{ item.consume_status|showWithdrawalStatus }}</div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <DialogBindUserInfoTip ref="dialogBindUserInfoTip"></DialogBindUserInfoTip>
  </div>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import NoneData from "@/components/NoneData";
import DialogBindUserInfoTip from "@/components/dialog/BindUserInfoTip";
import { formatDate } from "@/utils/tool";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import mywalletApi from "@/api/myWallet";
export default {
  name: "MyWallet",
  components: {
    NoneData,
    DialogBindUserInfoTip,
  },
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 3);
    _this.isRequesting=true;
    _this.selTabIndex=0;
    _this.currentPage=1;
    _this.total=1;
    _this.disabledLoadMore=true;
    _this.getWalletBase().then(()=>{
      _this.getConsumeRecordList();
    })
  },
  mounted() {
    let _this = this;
  },
  data() {
    return {
      consumeList: [],
      withdrawalList: [],
      userBalance: {},
      recordList:[],
      selTabIndex: 0,

      currentPage: 1,
      pageSize: 10,
      total: 1,
      disabledLoadMore: false,
      isRequesting: false,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  filters: {
    showStatus: function (val) {
      if (val) {
        return "远程开发";
      }
      return "本地开发";
    },
    showConsumeType: function (val) {
      if (val === 1) {
        return "余额支付";
      }
      if (val === 2) {
        return "佣金";
      }
      if (val === 201) {
        return "提现";
      }
      if (val === 3) {
        return "充值";
      }
    },
    showTime: function (val) {
      if (!val) {
        return;
      }
      let time = formatDate(
        new Date(val.replace(/-/g, "/")),
        "YYYY.MM.DD hh:mm:ss"
      );
      return time;
    },
    showMoney: function (val) {
      if (val) {
        return parseFloat(val).toFixed(2)
      }
      return parseFloat(0).toFixed(2);
    },
    showPlatform: function (val) {
      if (val === 0) {
        return "微信";
      }
      if (val === 1) {
        return "支付宝";
      }
    },
    showWithdrawalStatus: function (val) {
      console.log(val)
      if (val === 901) {
        return "审核中";
      }
      if (val === 903) {
        return "提现成功";
      }
      if (val === 902) {
        return "审核失败";
      }
    },
  },
  methods: {
    getWalletBase: function () {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (_this.userInfo && _this.userInfo.id_public_user_info) {
          let requestData = {
            begin_idx: 0,
            limit: 1000,
            id_public_user_info: _this.userInfo.id_public_user_info,
            isloading: true,
          };
          pageCommon.apiRequestCommon(mywalletApi, "getWithDrawalMoney", requestData).then(
            (res) => {
              console.log(res)
              _this.userBalance = res
              resolve();
            },
            (err) => {
              _this.isRequesting = false;
              if (err.sysUserLoginError) {
                _this.$message.error("系统异常，请稍后刷新重试！");
              } else {
                _this.$message.error(err.data.msg);
              }
              reject();
            }
          );
        }
        else {
          reject();
        }

      })

    },
    handleSelTab: function (idx) {
      let _this = this;
      if (_this.selTabIndex === idx) {
        return;
      }
      _this.selTabIndex = idx;
      _this.currentPage=1;
      _this.disabledLoadMore=true;
      _this.isRequesting=true;
      if(_this.selTabIndex===0){
        _this.getConsumeRecordList();
      }
      if(_this.selTabIndex===1){
        _this.getWithDrawalRecordList();
      }
    },
    getConsumeRecordList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        buyer_id: _this.userInfo.id_public_user_info,
        consume_type: 1,
        isloading: true,
      };
      pageCommon.apiRequestCommon(mywalletApi, "getConsumeRecord", requestData).then(
        (res) => {
          _this.recordList = []
          let recordList = res.page_content;
          if (recordList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }

          // 用concat
          _this.recordList.push(...recordList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          // _this.collectList = [];
          _this.isRequesting = false;
          _this.recordList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getWithDrawalRecordList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        buyer_id: _this.userInfo.id_public_user_info,
        consume_type: 201,
        isloading: true,
      };
      pageCommon.apiRequestCommon(mywalletApi, "getConsumeRecord", requestData).then(
        (res) => {
          _this.recordList = []
          let recordList = res.page_content;
          if (recordList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }

          // 用concat
          _this.recordList.push(...recordList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          // _this.collectList = [];
          _this.isRequesting = false;
          _this.recordList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting=true;
      _this.currentPage += 1;
      if(_this.selTabIndex===0){
        _this.getConsumeRecordList();
      }
      if(_this.selTabIndex===1){
        _this.getWithDrawalRecordList();
      }
    },
    handleWithdrawal: function () {
      let _this = this;
      if (!_this.userInfo.id_sns) {
        _this.$refs.dialogBindUserInfoTip.showDialog=true;
      } else if (Number(_this.userBalance.cust_stat_left_money_num) === 0) {
        this.$confirm('您的可提现余额为0, 暂时不能进行提现操作', '提示', {
          type: 'warning'
        }).then(() => {

        }).catch(() => {

        })
      } else {
        _this.$router.push({
          path: "/withdrawal",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.mywallet {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .wallet-basic-box {
    position: relative;
    width: 100%;
    height: 150px;
    background: linear-gradient(-90deg, #ec4040 0%, #ff8080 99%);
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 40px;
    .bg-mywallet {
      position: absolute;
      width: 92px;
      height: 97px;
      top: 27px;
      right: 101px;
    }
    .wallet-basic-inner {
      position: relative;
      width: 100%;
      padding-left: 30px;
      padding-top: 40px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      box-sizing: border-box;
      .basic-item {
        position: relative;
        height: 70px;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        .label {
          position: relative;
          width: 100%;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
          line-height: 16px;
          text-align: center;
        }
        .val-cont {
          position: relative;
          width: 100%;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: 800;
          color: #ffffff;
          line-height: 32px;
          text-align: center;
        }
      }
      .line {
        position: relative;
        width: 1px;
        height: 70px;
        background: #ffc7c7;
        border-radius: 50%;
      }
      .account-surplus {
        position: relative;
        width: 220px;
        height: 70px;
      }
      .canuse-surplus {
        position: relative;
        width: 256px;
        height: 70px;
      }
      .tixian-surplus {
        position: relative;
        width: 255px;
        height: 70px;
      }
    }
    .btn-withdrawal {
      position: absolute;
      top: 40px;
      right: 24px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .btn-withdrawal-main {
        position: relative;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        line-height: 16px;
        cursor: pointer;
      }
      .icon-remind {
        position: relative;
        width: 14px;
        height: 14px;
        margin-left: 7px;
      }
    }
  }
  .nav-tabpanel-box {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin-top: 40px;
    .item-nav-box {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #222222;
      line-height: 18px;

      box-sizing: border-box;
      cursor: pointer;
      margin-right: 64px;
      &.active {
        color: #ec4040;
        font-weight: bold;
        &::after {
          position: absolute;
          width: 100%;
          content: "";
          height: 4px;
          background: #ec4040;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    flex: 1;
    text-align: center;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .ordertype {
    width: 116px;
    text-align: left;
  }
  .orderpaytype {
    width: 114px;
    text-align: center;
  }
  .paytime {
    width: 198px;
    text-align: center;
  }
  .couponmoney {
    width: 124px;
    text-align: center;
  }
  .surplusmoney {
    width: 137px;
    text-align: center;
  }
  .realpay {
    width: 142px;
    text-align: center;
  }
  .orderstatus {
    width: 98px;
    text-align: right;
  }
  .distributionid {
    width: 151px;
    text-align: left;
  }
  .avatar {
    width: 42px;
    text-align: center;
    .user-avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
  }
  .username {
    width: 132px;
    text-align: center;
  }
  .userphone {
    width: 163px;
    text-align: center;
  }
  .distributionordertype {
    width: 141px;
    text-align: center;
  }
  .distributionmoney {
    width: 155px;
    text-align: center;
  }
  .fanyongmoney {
    width: 131px;
    text-align: center;
  }
  .table-header-box {
    position: relative;
    align-items: baseline;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 36px;
    margin-bottom: 20px;
    align-items: center;
    // &.recharge {
    //   align-items: baseline;
    //   padding-top: 18px;
    // }
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    position: relative;
    height: 80px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
    }
    .order-num-box {
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 24px;

      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      .order-num {
        padding-left: 10px;
      }
      .distribute-paytime {
        padding-left: 24px;
      }
    }
    .cell-row {
      margin-top: 31px;
    }
    &.distribution {
      .cell-row {
        margin-top: 18px;
      }
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    .couponmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .surplusmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .realpay {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
    }
    .distributionmoney {
      //  font-size: 16px;
      //     font-family: Source Han Sans CN;
      //     font-weight: bold;
      //     color: #000000;
    }
    .fanyongmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .consumemoney_status {
      font-weight: bold;
      &.consumemoney_status1 {
        color: #ec4040;
      }
    }
    .withdrawmoney {
      font-weight: bold;
      color: #ec4040;
    }
    .withdrawalstatus {
      &.withdrawalstatus901 {
        color: #0072ff;
      }
      &.withdrawalstatus902 {
        color: #ec4040;
      }
    }
  }
}
</style>
